/**
 * The one sentence every share path sends.
 *
 * Three callers produce a share message for a pool: the invite sheet's
 * `mailto:` composer, the invite sheet's `navigator.share` payload, and the
 * pool screen's own share button. ISSUE-952 R11 says those cannot silently
 * diverge, so the sentence is built here and nowhere else.
 *
 * The wording is the legacy app's own, quoted in ISSUE-952 R8. The link is
 * always Sportsmet's invite URL, resolved per role by
 * `inviteHeaderModel.ts`, never a legacy domain.
 *
 * Pure: no browser API, no React, no SDK.
 */
export const SHARE_MESSAGE_PREFIX = "You're invited to join ";
export const SHARE_MESSAGE_LINK_LEAD =
  " in the Sportsmet app. Use this link to join ";

export function buildPoolShareMessage({
  poolName,
  inviteUrl,
}: {
  poolName: string;
  inviteUrl: string;
}): string {
  return `${SHARE_MESSAGE_PREFIX}${poolName}${SHARE_MESSAGE_LINK_LEAD}${inviteUrl}`;
}
